import { BASKET_UPDATE } from '../constants';
import { BasketItem } from 'features/basket/types';
import { useEffectOnce } from './use-effect-once';

function isBasketUpdateEvent(e: Event): e is CustomEvent<BasketItem[]> {
  return 'detail' in e && Array.isArray((e as CustomEvent).detail);
}

export const useBasketUpdate = (load: () => void, update: (basket: BasketItem[]) => void): void => {
  useEffectOnce(() => {
    const handleBasketUpdate = (e: Event) => {
      if (isBasketUpdateEvent(e)) {
        update(e.detail);
      }
    };

    document.body.addEventListener(BASKET_UPDATE, handleBasketUpdate);
    load();

    return () => {
      document.body.removeEventListener(BASKET_UPDATE, handleBasketUpdate);
    };
  });
};
